export const TicketsData = [
  {
    id:"1",
    TicketID: "#TIC010",
    Date: "22Aug2025",
    Subject: "IssuewithCourseNotificationEmails",
    Priority: "High",
    Category: "MailingIssues",
    Status: "Opened",
  },
  {
    id:"2",
    TicketID: "#TIC009",
    Date: "10Aug2025",
    Subject: "Ihaveaproblem",
    Priority: "Low",
    Category: "LanguageIssues",
    Status: "Inprogress",

  },
  {
    id:"3",
    TicketID: "#TIC008",
    Date: "26Jul2025",
    Subject: "AccountActivationmailnotreceived",
    Priority: "High",
    Category: "MailingIssues",
    Status: "Closed",

  },
  {
    id:"4",
    TicketID: "#TIC007",
    Date: "12Jul2025",
    Subject: "EnablingSSHservice",
    Priority: "High",
    Category: "InstallationError",
    Status: "Opened",

  },
  {
    id:"5",
    TicketID: "#TIC006",
    Date: "02Jul2025",
    Subject: "PaymentProcessedbutnotshowed",
    Priority: "Low",
    Category: "PaymentIssues",
    Status: "Closed",

  },
  {
    id:"6",
    TicketID: "#TIC005",
    Date: "25Jun2025",
    Subject: "whenwillstarttheorder",
    Priority: "High",
    Category: "DemoProblem",
    Status: "Inprogress",
  },
  {
    id:"7",
    TicketID: "#TIC004",
    Date: "17Jun2025",
    Subject: "SlowspeedwhileCourseDownload",
    Priority: "High",
    Category: "ServerIssues",
    Status: "Closed",

  },
  {
    id:"8",
    TicketID: "#TIC003",
    Date: "04Jun2025",
    Subject: "Unabletoaccessthecourse",
    Priority: "Medium",
    Category: "DemoProblem",
    Status: "Closed",
  },
  {
    id:"9",
    TicketID: "#TIC002",
    Date: "20May2025",
    Subject: "AssignmentUploadErrorfiles",
    Priority: "Low",
    Category: "FileError",
    Status: "Closed",
  },
  {
    id:"10",
    TicketID: "#TIC001",
    Date: "15May2025",
    Subject: "AccountRecoveryAssistanceNeed",
    Priority: "High",
    Category: "RecoveryIssues",
    Status: "Closed",
  },
];
